import script from "./CanvasModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CanvasModal.vue?vue&type=script&setup=true&lang=js"

import "./CanvasModal.vue?vue&type=style&index=0&id=8c591904&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c591904"]])

export default __exports__